import styled from 'styled-components';

import { media } from '../../utils/mediaQueries';

export const Container = styled.footer`
    border-top: 1px solid ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#e8e8e8')};
    z-index: 10;
    position: sticky;
    bottom: 0;
    display: flex;
    padding: 10px 20px;
    align-items: center;
    width: 100%;
    background: ${({ theme }) => (theme.mode === 'dark' ? '#1a1f26' : 'white')};

    ${media.tabletDown} {
        position: fixed;
        left: 0;
        right: 0;
        padding: 8px 16px;
        gap: 8px;
        z-index: 50;
        /* Nad paskiem okresu próbnego, gdy jest widoczny (zmienną ustawia MobileTrialBar). */
        bottom: var(--hs-trial-bar-height, 0px);
    }
`;

export const LeftElement = styled.div`
    margin-right: auto;

    ${media.tabletDown} {
        button {
            padding: 0 14px;
            height: 36px;
            font-size: 14px;
            min-width: auto;
        }
    }
`;

export const RightElement = styled.div`
    margin-left: auto;
    display: flex;
    align-items: center;
    gap: 8px;

    ${media.tabletDown} {
        gap: 8px;

        button {
            padding: 0 14px;
            height: 36px;
            font-size: 14px;
            min-width: auto;
        }
    }
`;

// Przycisk pierwszorzędny (Zapisz / Następna) — czarny (w ciemnym motywie jasny),
// kompaktowy CTA w stylu przycisku z załącznika.
export const PrimaryButton = styled.button`
    padding: 7px 16px;
    background: ${({ theme }) => (theme.mode === 'dark' ? '#f3f4f6' : '#111827')};
    color: ${({ theme }) => (theme.mode === 'dark' ? '#111827' : '#ffffff')};
    border: none;
    border-radius: 6px;
    font-size: 13px;
    font-weight: 300;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    transition: all 0.2s ease;

    &:hover:not(:disabled) {
        background: ${({ theme }) => (theme.mode === 'dark' ? '#e5e7eb' : '#000000')};
    }

    &:disabled {
        cursor: not-allowed;
        opacity: 0.6;
    }

    ${media.tabletDown} {
        padding: 8px 14px;
        font-size: 13px;
        gap: 6px;
        border-radius: 6px;
    }
`;

// Przycisk drugorzędny (Anuluj / Wstecz) — jasny, w stylu przycisków z empty state.
export const SecondaryButton = styled.button`
    padding: 7px 16px;
    background: ${({ theme }) => (theme.mode === 'dark' ? 'rgba(255, 255, 255, 0.04)' : '#ffffff')};
    color: ${({ theme }) => (theme.mode === 'dark' ? '#e5e7eb' : '#374151')};
    border: 1px solid ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#dcdfe4')};
    border-radius: 6px;
    font-size: 13px;
    font-weight: 300;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    transition: all 0.2s ease;

    &:hover:not(:disabled) {
        background: ${({ theme }) => (theme.mode === 'dark' ? 'rgba(255, 255, 255, 0.08)' : '#f8fafc')};
        border-color: ${({ theme }) => (theme.mode === 'dark' ? '#4b5563' : '#cbd5e1')};
    }

    &:disabled {
        cursor: not-allowed;
        opacity: 0.6;
    }

    ${media.tabletDown} {
        padding: 8px 14px;
        font-size: 13px;
        gap: 6px;
        border-radius: 6px;
    }
`;
